function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  max-width: 100%;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { width } from 'styled-system';
var Image = styled.img.attrs(function (props) {
  return {
    height: props.height || 'auto'
  };
})(_templateObject(), width);
Image.displayName = 'Image';
export default Image;